import React, { FC, useCallback } from "react";
import { Marker } from "@react-google-maps/api";
import { Clusterer } from "@react-google-maps/marker-clusterer";

interface IMapProps {
  id?: number;
  selectedLocation?: number;
  location?: { lat: number; lng: number };
  clusterer?: Clusterer;
  onSelectLocation?: (id: number) => void;
}

const MapMarker: FC<IMapProps> = (props) => {
  const { id, selectedLocation, location, clusterer, onSelectLocation } = props;

  const markerSet = {
    blue: "assets/images/map_marker_blue.svg",
    red: "assets/images/map_marker_red.svg",
  };

  const onClickHandler = useCallback(
    () => onSelectLocation && onSelectLocation(id),
    [id, onSelectLocation],
  );

  return (
    <Marker
      onClick={onClickHandler}
      clusterer={clusterer}
      key={id}
      position={location}
      icon={{
        url: selectedLocation === id ? markerSet.red : markerSet.blue,
      }}
    />
  );
};

export default MapMarker;
